import { createIcon } from '../createIcon';

export const IndustryIconConfig = {
  name: 'IndustryIcon',
  height: 512,
  width: 512,
  svgPath: 'M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const IndustryIcon = createIcon(IndustryIconConfig);

export default IndustryIcon;